<template>
  <div id="sig-container" class="block full form-horizontal">
    <div class="loader" v-if="loading">
      <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
    </div>
    <div class="widget">
      <div
        class="
          widget-content widget-content-mini
          themed-background-dark-default
          text-light
        "
      >
        <span class="float-right text-muted">
          <button
            type="button"
            @click="$router.go(-1)"
            class="btn btn-xs btn-primary"
          >
            Volver
          </button>
        </span>
        Informe obligaciones - Referencias
      </div>
      <div
        class="widget-content border-bottom themed-background-muted text-center"
      >
        <div class="container">
          <div class="form-group text-center">
            <label
              class="control-label col-lg-3 col-md-2"
              v-text="'Fecha creación obligación'"
            ></label>
            <div class="col-lg-12 col-md-12">
              <date-picker
                id="datepicker"
                v-model="fecha_inicio"
                :placeholder="'Fecha inicio'"
                :bootstrap-styling="true"
                :clear-button="true"
                format="yyyy-MM-dd"
                :language="es"
              ></date-picker>
              <p id="space">
                <date-picker
                  id="datepicker"
                  v-model="fecha_fin"
                  :placeholder="'Fecha fin'"
                  :bootstrap-styling="true"
                  :clear-button="true"
                  format="yyyy-MM-dd"
                  :language="es"
                ></date-picker>
              </p>
            </div>
          </div>

          <div class="form-group">
            <label
              class="control-label col-lg-3 col-md-2"
              v-text="'Identificación del deudor'"
            ></label>
            <div class="col-lg-12 col-md-12">
              <input
                type="text"
                class="form-control"
                v-model="params.identificacion"
              />
            </div>
          </div>

          <div class="col-lg-12 col-md-12">
            <label
              class="control-label col-lg-3 col-md-2"
              v-text="'Referencia'"
            ></label>
            <div class="form-inline">
              <select
                class="form-control col-lg-3 col-md-2"
                v-model="params.indicador_referencia"
              >
                <option :value="null">Seleccione el indicador</option>
                <option
                  v-for="indicador in indicadores"
                  :key="indicador.value"
                  :value="indicador.value"
                >
                  {{ indicador.text }}
                </option>
              </select>

              <input
                type="number"
                min="0"
                step="1"
                class="form-control col-lg-9 col-md-2"
                v-model="params.referencia"
              />
            </div>
          </div>
          <br />

          <div class="form-actions">
            <button class="btn btn-primary" @click="index()">Aplicar</button
            >&nbsp;
            <button class="btn btn-primary" @click="descargarConsulta()">
              Descargar excel
            </button>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="loader" v-if="loading">
        <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
      </div>
      <table-component :data="datos">
        <table-column
          slot="label"
          :label="'Referencia'"
          v-bind:value="'referencia'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Identificación'"
          v-bind:value="'identificacion'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Nombre'"
          v-bind:value="'nombre'"
        ></table-column>
        <table-column
          slot="label"
          :label="'N° garantía'"
          v-bind:value="'id_garantia'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Pagaré'"
          v-bind:value="'pagare'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Nombre banco'"
          v-bind:value="'nombre_banco'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Convenio'"
          v-bind:value="'convenio'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha primer pago'"
          v-bind:value="'acuerdo.fecha_primer_pago'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Día de pago'"
          v-bind:value="'acuerdo.dia_pago'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Cuotas'"
          v-bind:value="'acuerdo.cuotas'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Valor cuotas'"
          v-bind:value="'acuerdo.valor_cuota'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Estado'"
          v-bind:value="'acuerdo.estado'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Valor cuota inicial'"
          v-bind:value="'acuerdo.valor_cuota_inicial'"
        ></table-column>
        <!--table-column slot="label" :label="'Acciones'" :icon="'fa'">
          <template
            slot="icon"
            :icon="'fa fa-search'"
            :class="'btn btn-sm btn-primary'"
            :slug="'ver'"
            :tooltip="'Ver'"
          ></template>
        </table-column-->
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";

export default {
  name: "Gestiones",
  data: () => {
    return {
      params: {
        identificacion: null,
        referencia: null,
        indicador_referencia: null,
        fecha_inicio: null,
        fecha_fin: null,
        paginar: "false",
        page: 1,
      },
      fecha_inicio: null,
      fecha_fin: null,
      datos: [],
      es: es,
      errors: null,
      indicadores: [
        {
          text: "O",
          value: "O",
        },
        {
          text: "A",
          value: "A",
        },
      ],
    };
  },
  components: {
    TableComponent: () => import("@@/components/table/TableComponent"),
    TableColumn: () => import("@@/components/table/TableColumn"),
    "date-picker": Datepicker,
  },
  computed: {
    ...mapGetters({ loading: "loading" }),
  },
  methods: {
    index() {
      if (
        (this.params.identificacion === null ||
          this.params.identificacion == "") &&
        (this.params.referencia == null ||
          this.params.indicador_referencia == null ||
          this.params.referencia == "" ||
          this.params.indicador_referencia == "")
      ) {
        this.$notify({
          title: "Advertencia!",
          type: "danger",
          content:
            "Por favor ingrese una identificación o referencia para realizar la consulta.",
        });
      } else {
        this.$store
          .dispatch("index", {
            endpoint: "informes/informe-obligacion",
            params: this.params,
          })
          .then((response) => {
            this.datos = response.datos;
          })
          .catch((error) => {
            this.errors = error.data.errors;
            this.$notify({
              title: "Advertencia!",
              type: "danger",
              content: "Se ha presentado un error realizando su consulta",
            });
          });
      }
    },
    descargarConsulta() {
      let data = this.datos;
      data.forEach((element) => {
        delete element.id;
        element.fecha_primer_pago = element.acuerdo.fecha_primer_pago;
        element.dia_pago = element.acuerdo.dia_pago;
        element.cuota = element.acuerdo.cuota;
        element.valor_cuota = element.acuerdo.valor_cuota;
        element.estado = element.acuerdo.estado;
        element.valor_cuota_inicial = element.acuerdo.valor_cuota_inicial;
        delete element.acuerdo;
        delete element.gestion_obligacion;
      });

      data = XLSX.utils.json_to_sheet(data, {
        header: [
          "referencia",
          "identificacion",
          "nombre",
          "id_garantia",
          "pagare",
          "nombre_banco",
          "convenio",
          "fecha_primer_pago",
          "dia_pago",
          "cuota",
          "valor_cuota",
          "estado",
          "valor_cuota_inicial",
        ],
      });

      data["A1"].v = "Referencia";
      data["B1"].v = "Identificación";
      data["C1"].v = "Nombre";
      data["D1"].v = "N° Garantía";
      data["E1"].v = "Pagare";
      data["F1"].v = "Convenio";
      data["G1"].v = "Nombre Banco";
      data["H1"].v = "Fecha primer pago";
      data["I1"].v = "Día pago";
      data["J1"].v = "Cuota";
      data["K1"].v = "Valor cuota";
      data["L1"].v = "Estado";
      data["M1"].v = "Valor cuota inicial";

      var workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, data, "Referencias");
      var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
      var wbout = XLSX.write(workbook, wopts);
      saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        "Referencias.xlsx"
      );
    },
  },
  watch: {
    fecha_inicio: function (newVal, oldVal) {
      var d = new Date(newVal),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      this.params.fecha_inicio = [year, month, day].join("-");

      if ((this.params.fecha_inicio = "1969-12-31")) {
        this.params.fecha_inicio = null;
      }
    },
    fecha_fin: function (newVal, oldVal) {
      var d = new Date(newVal),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      this.params.fecha_fin = [year, month, day].join("-");

      if ((this.params.fecha_fin = "1969-12-31")) {
        this.params.fecha_fin = null;
      }
    },
  },
  mounted() {
    //
  },
};
</script>
<style>
#space {
  padding-top: 10px;
}
#datepicker {
  background: white;
  padding-top: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.disponibles {
  display: flow-root !important;
}
.titulos-disponible {
  padding-left: initial !important;
  padding-right: initial !important;
}
.table thead > tr > th {
  font-size: 14px !important;
}

.table thead > tr > td {
  font-size: 10px !important;
}

.table-responsive {
  overflow: auto !important;
  width: 100%;
}
</style>